// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  
}

.add_lead_popup_container {
  background: #ffffff;
  width: 90%;
  max-width: 500px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  position: relative;
  animation: fadeIn 0.3s ease-in-out;
}

.add_lead_popup_container h2 {
  text-align: center;
  margin-bottom: 15px;
  font-size: 1.5rem;
  color: #333333;
}

.closeAddlead {
  position: absolute;
  top: 15px;
  right: 15px;
}

.closeAddlead button {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
}

.add_lead_form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.input-containerr {
  position: relative;
  margin-bottom: 5px;
}

.input-containerr input {
  width: 100%;
  padding: 10px 12px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  outline: none;
  transition: all 0.3s ease-in-out;
}

.input-containerr input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.input-containerr label {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  font-size: 0.9rem;
  color: #aaa;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.input-containerr input:focus + label,
.input-containerr input:not(:placeholder-shown) + label {
  top: -10px;
  left: 10px;
  font-size: 0.8rem;
  color: #007bff;
  background: #fff;
  padding: 0 5px;
}

.lead_button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 15px;
  font-size: 1rem;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
}

.lead_button:hover {
  background-color: #0056b3;
}

/* Responsive Design for Mobile */
@media (max-width: 768px) {
  .add_lead_popup_container {
    padding: 15px;
  }

  .add_lead_popup_container h2 {
    font-size: 1.3rem;
  }

  .input-containerr input {
    font-size: 0.9rem;
    padding: 8px 10px;
  }

  .input-containerr label {
    font-size: 0.8rem;
  }

  .lead_button {
    font-size: 0.9rem;
    padding: 8px 12px;
  }
}

@media (max-width: 480px) {
  .add_lead_popup_container {
    width: 95%;
    padding: 10px;
    border-radius: 8px;
  }

  .add_lead_popup_container h2 {
    font-size: 1.2rem;
  }

  .input-containerr input {
    font-size: 0.8rem;
    padding: 7px 10px;
  }

  .lead_button {
    font-size: 0.8rem;
    padding: 7px 10px;
  }

  .closeAddlead button {
    font-size: 1rem;
  }
}

/* Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

/*  lead table css */
.lead_search_with_button {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
}
.lead_search_with_button button {
  height: 40px;
  width: 110px;
  border-radius: 10px;
  border: none;
}
.lead_search_with_button button:nth-child(1) {
    background-color: #ffffff;
    color: #ff9800;
    font-size: 15px;
    font-weight: 700;
    border: 1px solid #ff9800;
}
.lead_search_with_button button:nth-child(2) {
  background-color: #ffffff;
  color: #f44336;
  font-size: 15px;
  font-weight: 700;
  border:1px solid #f44336;
}
.lead_search_with_button button:nth-child(3) {
  background-color: #ffffff;
  color: #2196f3;
  font-size: 15px;
  font-weight: 700;
  border: 1px solid #2196f3;
}
.lead_search_with_button button:nth-child(4) {
  background-color: #ffffff;
  color: #9c27b0;
  font-size: 15px;
  font-weight: 700;
  border:1px solid #9c27b0;
}
.lead_search_with_button button:nth-child(5) {
  background-color: #ffffff;
  color: #009688;
  font-size: 15px;
  font-weight: 700;
  border: 1px solid #009688;
}
.lead_search_with_button button:nth-child(6) {
  background-color: #ffffff;
  color: #4caf50;
  font-size: 15px;
  font-weight: 700;
  border: 1px solid #4caf50;
}
.lead_search_with_button button:nth-child(7) {
  background-color: #ffffff;
  color: #ffc107;
  font-size: 15px;
  font-weight: 700;
  border: 1px solid #ffc107;
}
.lead-show-table {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 20px;
}

.won-leads h2 {
  font-size: 24px;
  margin-bottom: 20px;
  padding: 20px;
  background-color: #f7f7f7;
}

.search-add {
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
}
.search-bar {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px 10px;
  width: 100%;
  max-width: 460px;
  border-radius: 50px;
  box-shadow: 2px 0 15px #04847e48;
}

.search-bar input {
  border: none;
  outline: none;
  padding: 8px;
  width: 100%;
}

.search-icon {
  color: #888;
}

.add_lead_button {
  height: 40px;
  width: 120px;
  border-radius: 10px;
  border: none;
  outline: none;
  color: white;
  background-color: #d65b3c;
  font-size: 17px;
  font-weight: 700;
}

.add_lead_step_button {
  border-radius: 10px;
  border: none;
  outline: none;
  color: white;
  background-color: #61b6ad;
  font-size: 14px;
  font-weight: 700;
  height: 40px;
  width: 70px;
}

.add_lead_view_button {
  border-radius: 10px;
  border: none;
  outline: none;
  color: white;
  background-color: #ffc107;
  font-size: 14px;
  font-weight: 700;
  height: 40px;
  width: 70px;
}

.add_lead_delete_button {
  border-radius: 10px;
  border: none;
  outline: none;
  color: white;
  background-color: orangered;
  font-size: 14px;
  font-weight: 700;
  width: 60px;
  height: 40px;
  width: 70px;
}

.add_lead_edit_button {
  border-radius: 10px;
  border: none;
  outline: none;
  color: white;
  background-color: #007bff;
  font-size: 14px;
  font-weight: 700;
  width: 60px;
  height: 40px;
  width: 70px;
}

.add_lead_review_button {
  border-radius: 10px;
  border: none;
  outline: none;
  color: white;
  background-color: #61b6ad;
  font-size: 14px;
  font-weight: 700;
  width: 60px;
  height: 40px;
  width: 79px;
}
.responsive-table {
  width: 100%;
  border-collapse: collapse;
  /* margin: 30px; */
  overflow-x: auto;
  display: block;
}

.responsive-table th,
.responsive-table td {
  text-align: center;
  padding: 12px 15px;
  border: 1px solid #ddd;
}
.responsive-table th {
    background-color: #fff2ef;
    font-weight: bold;
    color: #dc641a;
    border: 1px solid #ddd;
}

.responsive-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.responsive-table tr:hover {
  background-color: #f1f1f1;
}

.responsive-table td button {
  margin: 2px;
  border-radius: 4px;
}

.pagination {
  display: flex;
  justify-content: center;
  margin: 20px 0;
  text-decoration: none;
  list-style-type: none;
}

.pagination a {
  padding: 8px 12px;
  margin: 0 5px;
  background-color: #f4f7fc;
  border: 1px solid #ddd;
  border-radius: 5px;
  color: #333;
  text-decoration: none;
  list-style-type: none;
}

.pagination a.active {
  background-color: #008cba;
  color: white;
}

.pagination a:hover {
  background-color: #ddd;
}

/* Media Queries for responsiveness */
@media (max-width: 1200px) {
  .search-add {
    justify-content: space-around;
  }

  .search-bar {
    width: 60%;
  }

  .btn-primary {
    max-width: 200px;
  }

  .pagination a {
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .won-leads h2 {
    font-size: 20px;
    padding: 15px;
  }

  .search-add {
    flex-direction: row;
    align-items: flex-start;
  }

  .search-bar {
    width: 100%;
    margin-bottom: 10px;
  }

  .btn-primary {
    width: 100%;
    margin-top: 10px;
  }

  .responsive-table th,
  .responsive-table td {
    padding: 10px;
  }

  .pagination a {
    font-size: 12px;
    padding: 6px 10px;
  }

  .pagination {
    flex-direction: row;
  }
  .lead_search_with_button {
    flex-wrap: wrap;
  }
}

@media (max-width: 480px) {
  .won-leads h2 {
    font-size: 18px;
    padding: 10px;
  }

  .search-add {
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }

  .search-bar input {
    padding: 6px;
    font-size: 14px;
  }

  .btn-primary {
    padding: 8px;
    width: 100%;
  }

  .responsive-table th,
  .responsive-table td {
    padding: 8px;
    font-size: 14px;
  }

  .pagination a {
    font-size: 10px;
    padding: 5px 8px;
  }

  .responsive-table td {
    word-wrap: break-word;
  }
}

/* step form */
.stepform_container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.stepForm_popup {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
}

.StepForm_close_btn {
  position: absolute;
  top: -60px;
  right: 10px;
  font-size: 20px;
  background: none;
  border: none;
  cursor: pointer;
  color: #333;
  font-weight: bold;
  transition: color 0.3s ease;
  height: 40px;
  width: 40px;
  background-color: red;
  border-radius: 50px;
}

.StepForm_close_btn:hover {
  color: red;
}

.step_from {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.stepform_container_input,
.stepform_container_select {
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.stepform_container_submit_button {
  padding: 12px;
  background-color: #027a8d;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

.stepform_container_submit_button:hover {
  background-color: #45a049;
}

@media (max-width: 768px) {
  .stepForm_popup {
    width: 90%;
    padding: 15px;
  }

  .stepform_container_input,
  .stepform_container_select,
  .stepform_container_submit_button {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .stepForm_popup {
    width: 95%;
  }

  .StepForm_close_btn {
    font-size: 22px;
  }
}

/*  view css */
.main_card_wrapper {
  position: relative;
}

.final_card_details {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.Final_card_popup {
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  width: 80%;
  max-width: 750px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow-y: auto;
  max-height: 80%;
}

.finalCardClose {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 30px;
  background: none;
  border: none;
  color: #333;
  cursor: pointer;
  font-weight: bold;
  transition: color 0.3s ease;
}

.finalCardClose:hover {
  color: red;
}

h3,
h4 {
  color: #333;
  font-size: 24px;
  margin-bottom: 10px;
}

.lead_detail_wrapper {
  margin-bottom: 25px;
}

.detail_item {
  font-size: 16px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  font-weight: 500;
}

.lead_logs {
  margin-bottom: 25px;
}

.lead_logs_grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.log_item {
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.remark_section p {
  font-size: 16px;
  margin-bottom: 12px;
}

strong {
  color: #333;
}

@media (max-width: 768px) {
  .Final_card_popup {
    width: 90%;
    padding: 25px;
  }

  .finalCardClose {
    font-size: 26px;
    margin-right: -255px;
    color: red;
  }

  h3,
  h4 {
    font-size: 20px;
  }

  .lead_detail_wrapper .detail_item {
    font-size: 14px;
  }

  .lead_logs_grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 480px) {
  .Final_card_popup {
    width: 95%;
    padding: 20px;
  }

  .finalCardClose {
    font-size: 24px;
    margin-right: -121px;
    color: red;
  }

  h3,
  h4 {
    font-size: 18px;
  }

  .lead_detail_wrapper .detail_item {
    font-size: 12px;
  }

  .lead_logs_grid {
    grid-template-columns: 1fr;
  }
}

/* edit css */
/* Base Styles */
.edit_lead_main_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.edit_lead_form_container {
  width: 100%;
  max-width: 800px;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.edit_lead_form_container h2 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
  color: #333;
}

.edit_lead_form {
  display: flex;
  flex-direction: column;
}

.edit_lead_input {
  position: relative;
  margin-bottom: 20px;
}

.edit_lead_input input,
.edit_lead_input select {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  outline: none;
}

.edit_lead_input label {
  position: absolute;
  top: 12px;
  left: 12px;
  font-size: 16px;
  color: #888;
  transition: 0.3s;
}

.edit_lead_input input:focus + label,
.edit_lead_input select:focus + label,
.edit_lead_input input:not(:placeholder-shown) + label,
.edit_lead_input select:not(:placeholder-shown) + label {
  top: -8px;
  left: 12px;
  font-size: 12px;
  color: #007bff;
}

.editSelect {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* Lead Logs Section */
.lead_logs_section {
  margin-top: 20px;
}

.lead_log_input {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.lead_log_input input,
.lead_log_input select {
  width: 100%;
}

/* Customer Review Section */
.edit_lead_customet_review_input {
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 20px;
}

.edit_lead_customet_ {
  background-color: #007bff;
  color: white;
  padding: 14px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.edit_lead_customet_:hover {
  background-color: #0056b3;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .edit_lead_form_container {
    padding: 15px;
    margin-top: 10px;
  }

  .edit_lead_form {
    flex-direction: column;
  }

  .edit_lead_input {
    margin-bottom: 16px;
  }

  .edit_lead_input input,
  .edit_lead_input select {
    padding: 10px;
  }

  .edit_lead_form_container h2 {
    font-size: 22px;
  }

  .edit_lead_customet_review_input {
    font-size: 14px;
  }

  .edit_lead_customet_ {
    padding: 12px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .edit_lead_form_container {
    padding: 10px;
    margin-top: 10px;
  }

  .edit_lead_input input,
  .edit_lead_input select,
  .edit_lead_customet_review_input {
    font-size: 14px;
    padding: 10px;
  }

  .edit_lead_customet_ {
    padding: 10px;
    font-size: 14px;
  }

  .edit_lead_form_container h2 {
    font-size: 20px;
  }
}

/* review  css */

.add_deview_main_container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.add_deview_container {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  margin: 10px;
}

.add_deview_container p {
  font-size: 22px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  text-align: center;
}

.addreview_close_btn {
  position: absolute;
  top: 5px;
  right: 10px;

  border: none;
  font-size: 20px;
  color: #333;
  cursor: pointer;
  transition: color 0.3s;
  height: 40px;
  width: 40px;
  background-color: red;
  border-radius: 50px;
  color: white;
}

.addreview_close_btn:hover {
  color: #007bff;
}

.add_review_from {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.add_review_input {
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  outline: none;
}

.add_review_submit_button {
  background-color: #007bff;
  color: white;
  padding: 14px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.add_review_submit_button:hover {
  background-color: #0056b3;
}

@media (max-width: 1024px) {
  .add_deview_container {
    max-width: 80%;
    padding: 20px;
  }

  .add_deview_container p {
    font-size: 20px;
  }

  .add_review_input,
  .add_review_submit_button {
    font-size: 14px;
    padding: 12px;
  }
}

@media (max-width: 768px) {
  .add_deview_container {
    max-width: 90%;
    padding: 15px;
  }

  .add_deview_container p {
    font-size: 18px;
  }

  .add_review_input,
  .add_review_submit_button {
    font-size: 14px;
    padding: 10px;
  }

  .addreview_close_btn {
    font-size: 18px;
    height: 35px;
    width: 35px;
    background-color: red;
    color: wheat;
    border-radius: 50px;
  }
}

@media (max-width: 480px) {
  .add_deview_container {
    max-width: 95%;
    padding: 10px;
  }

  .add_deview_container p {
    font-size: 16px;
  }

  .add_review_input,
  .add_review_submit_button {
    font-size: 14px;
    padding: 8px;
  }

  .addreview_close_btn {
    font-size: 16px;
    height: 30px;
    width: 30px;
  }
}
.lead_button_loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.lead_spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: lead-spin 0.7s linear infinite;
}

@keyframes lead-spin {
  to { transform: rotate(360deg); }
}

.lead_button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.add_lead_scroll {
  max-height: 90vh;
  overflow-y: auto;
  overscroll-behavior: contain;
}

/* optional: nicer scrollbar */
.add_lead_scroll::-webkit-scrollbar {
  width: 6px;
}
.add_lead_scroll::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.edit_lead_error_banner {
  background: #fdecea;
  color: #b3261e;
  border: 1px solid #f5c6c2;
  padding: 10px 14px;
  border-radius: 6px;
  margin-bottom: 16px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/pages/lead/Lead.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;;AAEf;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;;EAEE,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA,cAAc;AACd;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,cAAc;AACd;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,UAAU;EACZ;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,UAAU;EACZ;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,aAAa;AACb,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;EAIE,SAAS;EACT,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;;;IAGE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,gBAAgB;;AAEhB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;;EAEX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  \n}\n\n.add_lead_popup_container {\n  background: #ffffff;\n  width: 90%;\n  max-width: 500px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  position: relative;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.add_lead_popup_container h2 {\n  text-align: center;\n  margin-bottom: 15px;\n  font-size: 1.5rem;\n  color: #333333;\n}\n\n.closeAddlead {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n}\n\n.closeAddlead button {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  cursor: pointer;\n}\n\n.add_lead_form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.input-containerr {\n  position: relative;\n  margin-bottom: 5px;\n}\n\n.input-containerr input {\n  width: 100%;\n  padding: 10px 12px;\n  font-size: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  outline: none;\n  transition: all 0.3s ease-in-out;\n}\n\n.input-containerr input:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n}\n\n.input-containerr label {\n  position: absolute;\n  top: 50%;\n  left: 15px;\n  transform: translateY(-50%);\n  font-size: 0.9rem;\n  color: #aaa;\n  pointer-events: none;\n  transition: all 0.3s ease-in-out;\n}\n\n.input-containerr input:focus + label,\n.input-containerr input:not(:placeholder-shown) + label {\n  top: -10px;\n  left: 10px;\n  font-size: 0.8rem;\n  color: #007bff;\n  background: #fff;\n  padding: 0 5px;\n}\n\n.lead_button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  font-size: 1rem;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease-in-out;\n}\n\n.lead_button:hover {\n  background-color: #0056b3;\n}\n\n/* Responsive Design for Mobile */\n@media (max-width: 768px) {\n  .add_lead_popup_container {\n    padding: 15px;\n  }\n\n  .add_lead_popup_container h2 {\n    font-size: 1.3rem;\n  }\n\n  .input-containerr input {\n    font-size: 0.9rem;\n    padding: 8px 10px;\n  }\n\n  .input-containerr label {\n    font-size: 0.8rem;\n  }\n\n  .lead_button {\n    font-size: 0.9rem;\n    padding: 8px 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .add_lead_popup_container {\n    width: 95%;\n    padding: 10px;\n    border-radius: 8px;\n  }\n\n  .add_lead_popup_container h2 {\n    font-size: 1.2rem;\n  }\n\n  .input-containerr input {\n    font-size: 0.8rem;\n    padding: 7px 10px;\n  }\n\n  .lead_button {\n    font-size: 0.8rem;\n    padding: 7px 10px;\n  }\n\n  .closeAddlead button {\n    font-size: 1rem;\n  }\n}\n\n/* Animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/*  lead table css */\n.lead_search_with_button {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n.lead_search_with_button button {\n  height: 40px;\n  width: 110px;\n  border-radius: 10px;\n  border: none;\n}\n.lead_search_with_button button:nth-child(1) {\n    background-color: #ffffff;\n    color: #ff9800;\n    font-size: 15px;\n    font-weight: 700;\n    border: 1px solid #ff9800;\n}\n.lead_search_with_button button:nth-child(2) {\n  background-color: #ffffff;\n  color: #f44336;\n  font-size: 15px;\n  font-weight: 700;\n  border:1px solid #f44336;\n}\n.lead_search_with_button button:nth-child(3) {\n  background-color: #ffffff;\n  color: #2196f3;\n  font-size: 15px;\n  font-weight: 700;\n  border: 1px solid #2196f3;\n}\n.lead_search_with_button button:nth-child(4) {\n  background-color: #ffffff;\n  color: #9c27b0;\n  font-size: 15px;\n  font-weight: 700;\n  border:1px solid #9c27b0;\n}\n.lead_search_with_button button:nth-child(5) {\n  background-color: #ffffff;\n  color: #009688;\n  font-size: 15px;\n  font-weight: 700;\n  border: 1px solid #009688;\n}\n.lead_search_with_button button:nth-child(6) {\n  background-color: #ffffff;\n  color: #4caf50;\n  font-size: 15px;\n  font-weight: 700;\n  border: 1px solid #4caf50;\n}\n.lead_search_with_button button:nth-child(7) {\n  background-color: #ffffff;\n  color: #ffc107;\n  font-size: 15px;\n  font-weight: 700;\n  border: 1px solid #ffc107;\n}\n.lead-show-table {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.won-leads h2 {\n  font-size: 24px;\n  margin-bottom: 20px;\n  padding: 20px;\n  background-color: #f7f7f7;\n}\n\n.search-add {\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n  flex-wrap: wrap;\n}\n.search-bar {\n  display: flex;\n  align-items: center;\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 5px 10px;\n  width: 100%;\n  max-width: 460px;\n  border-radius: 50px;\n  box-shadow: 2px 0 15px #04847e48;\n}\n\n.search-bar input {\n  border: none;\n  outline: none;\n  padding: 8px;\n  width: 100%;\n}\n\n.search-icon {\n  color: #888;\n}\n\n.add_lead_button {\n  height: 40px;\n  width: 120px;\n  border-radius: 10px;\n  border: none;\n  outline: none;\n  color: white;\n  background-color: #d65b3c;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.add_lead_step_button {\n  border-radius: 10px;\n  border: none;\n  outline: none;\n  color: white;\n  background-color: #61b6ad;\n  font-size: 14px;\n  font-weight: 700;\n  height: 40px;\n  width: 70px;\n}\n\n.add_lead_view_button {\n  border-radius: 10px;\n  border: none;\n  outline: none;\n  color: white;\n  background-color: #ffc107;\n  font-size: 14px;\n  font-weight: 700;\n  height: 40px;\n  width: 70px;\n}\n\n.add_lead_delete_button {\n  border-radius: 10px;\n  border: none;\n  outline: none;\n  color: white;\n  background-color: orangered;\n  font-size: 14px;\n  font-weight: 700;\n  width: 60px;\n  height: 40px;\n  width: 70px;\n}\n\n.add_lead_edit_button {\n  border-radius: 10px;\n  border: none;\n  outline: none;\n  color: white;\n  background-color: #007bff;\n  font-size: 14px;\n  font-weight: 700;\n  width: 60px;\n  height: 40px;\n  width: 70px;\n}\n\n.add_lead_review_button {\n  border-radius: 10px;\n  border: none;\n  outline: none;\n  color: white;\n  background-color: #61b6ad;\n  font-size: 14px;\n  font-weight: 700;\n  width: 60px;\n  height: 40px;\n  width: 79px;\n}\n.responsive-table {\n  width: 100%;\n  border-collapse: collapse;\n  /* margin: 30px; */\n  overflow-x: auto;\n  display: block;\n}\n\n.responsive-table th,\n.responsive-table td {\n  text-align: center;\n  padding: 12px 15px;\n  border: 1px solid #ddd;\n}\n.responsive-table th {\n    background-color: #fff2ef;\n    font-weight: bold;\n    color: #dc641a;\n    border: 1px solid #ddd;\n}\n\n.responsive-table tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.responsive-table tr:hover {\n  background-color: #f1f1f1;\n}\n\n.responsive-table td button {\n  margin: 2px;\n  border-radius: 4px;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  margin: 20px 0;\n  text-decoration: none;\n  list-style-type: none;\n}\n\n.pagination a {\n  padding: 8px 12px;\n  margin: 0 5px;\n  background-color: #f4f7fc;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  color: #333;\n  text-decoration: none;\n  list-style-type: none;\n}\n\n.pagination a.active {\n  background-color: #008cba;\n  color: white;\n}\n\n.pagination a:hover {\n  background-color: #ddd;\n}\n\n/* Media Queries for responsiveness */\n@media (max-width: 1200px) {\n  .search-add {\n    justify-content: space-around;\n  }\n\n  .search-bar {\n    width: 60%;\n  }\n\n  .btn-primary {\n    max-width: 200px;\n  }\n\n  .pagination a {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 768px) {\n  .won-leads h2 {\n    font-size: 20px;\n    padding: 15px;\n  }\n\n  .search-add {\n    flex-direction: row;\n    align-items: flex-start;\n  }\n\n  .search-bar {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n\n  .btn-primary {\n    width: 100%;\n    margin-top: 10px;\n  }\n\n  .responsive-table th,\n  .responsive-table td {\n    padding: 10px;\n  }\n\n  .pagination a {\n    font-size: 12px;\n    padding: 6px 10px;\n  }\n\n  .pagination {\n    flex-direction: row;\n  }\n  .lead_search_with_button {\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 480px) {\n  .won-leads h2 {\n    font-size: 18px;\n    padding: 10px;\n  }\n\n  .search-add {\n    flex-direction: column;\n    align-items: center;\n    gap: 5px;\n  }\n\n  .search-bar input {\n    padding: 6px;\n    font-size: 14px;\n  }\n\n  .btn-primary {\n    padding: 8px;\n    width: 100%;\n  }\n\n  .responsive-table th,\n  .responsive-table td {\n    padding: 8px;\n    font-size: 14px;\n  }\n\n  .pagination a {\n    font-size: 10px;\n    padding: 5px 8px;\n  }\n\n  .responsive-table td {\n    word-wrap: break-word;\n  }\n}\n\n/* step form */\n.stepform_container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.stepForm_popup {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n\n.StepForm_close_btn {\n  position: absolute;\n  top: -60px;\n  right: 10px;\n  font-size: 20px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #333;\n  font-weight: bold;\n  transition: color 0.3s ease;\n  height: 40px;\n  width: 40px;\n  background-color: red;\n  border-radius: 50px;\n}\n\n.StepForm_close_btn:hover {\n  color: red;\n}\n\n.step_from {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.stepform_container_input,\n.stepform_container_select {\n  padding: 12px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.stepform_container_submit_button {\n  padding: 12px;\n  background-color: #027a8d;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.3s ease;\n}\n\n.stepform_container_submit_button:hover {\n  background-color: #45a049;\n}\n\n@media (max-width: 768px) {\n  .stepForm_popup {\n    width: 90%;\n    padding: 15px;\n  }\n\n  .stepform_container_input,\n  .stepform_container_select,\n  .stepform_container_submit_button {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .stepForm_popup {\n    width: 95%;\n  }\n\n  .StepForm_close_btn {\n    font-size: 22px;\n  }\n}\n\n/*  view css */\n.main_card_wrapper {\n  position: relative;\n}\n\n.final_card_details {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.Final_card_popup {\n  background-color: white;\n  padding: 30px;\n  border-radius: 10px;\n  width: 80%;\n  max-width: 750px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow-y: auto;\n  max-height: 80%;\n}\n\n.finalCardClose {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  font-size: 30px;\n  background: none;\n  border: none;\n  color: #333;\n  cursor: pointer;\n  font-weight: bold;\n  transition: color 0.3s ease;\n}\n\n.finalCardClose:hover {\n  color: red;\n}\n\nh3,\nh4 {\n  color: #333;\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n\n.lead_detail_wrapper {\n  margin-bottom: 25px;\n}\n\n.detail_item {\n  font-size: 16px;\n  margin-bottom: 15px;\n  display: flex;\n  justify-content: space-between;\n  font-weight: 500;\n}\n\n.lead_logs {\n  margin-bottom: 25px;\n}\n\n.lead_logs_grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.log_item {\n  background-color: #f9f9f9;\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.remark_section p {\n  font-size: 16px;\n  margin-bottom: 12px;\n}\n\nstrong {\n  color: #333;\n}\n\n@media (max-width: 768px) {\n  .Final_card_popup {\n    width: 90%;\n    padding: 25px;\n  }\n\n  .finalCardClose {\n    font-size: 26px;\n    margin-right: -255px;\n    color: red;\n  }\n\n  h3,\n  h4 {\n    font-size: 20px;\n  }\n\n  .lead_detail_wrapper .detail_item {\n    font-size: 14px;\n  }\n\n  .lead_logs_grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .Final_card_popup {\n    width: 95%;\n    padding: 20px;\n  }\n\n  .finalCardClose {\n    font-size: 24px;\n    margin-right: -121px;\n    color: red;\n  }\n\n  h3,\n  h4 {\n    font-size: 18px;\n  }\n\n  .lead_detail_wrapper .detail_item {\n    font-size: 12px;\n  }\n\n  .lead_logs_grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* edit css */\n/* Base Styles */\n.edit_lead_main_wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.edit_lead_form_container {\n  width: 100%;\n  max-width: 800px;\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.edit_lead_form_container h2 {\n  text-align: center;\n  margin-bottom: 20px;\n  font-size: 24px;\n  color: #333;\n}\n\n.edit_lead_form {\n  display: flex;\n  flex-direction: column;\n}\n\n.edit_lead_input {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.edit_lead_input input,\n.edit_lead_input select {\n  width: 100%;\n  padding: 12px;\n  font-size: 16px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  outline: none;\n}\n\n.edit_lead_input label {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  font-size: 16px;\n  color: #888;\n  transition: 0.3s;\n}\n\n.edit_lead_input input:focus + label,\n.edit_lead_input select:focus + label,\n.edit_lead_input input:not(:placeholder-shown) + label,\n.edit_lead_input select:not(:placeholder-shown) + label {\n  top: -8px;\n  left: 12px;\n  font-size: 12px;\n  color: #007bff;\n}\n\n.editSelect {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n/* Lead Logs Section */\n.lead_logs_section {\n  margin-top: 20px;\n}\n\n.lead_log_input {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.lead_log_input input,\n.lead_log_input select {\n  width: 100%;\n}\n\n/* Customer Review Section */\n.edit_lead_customet_review_input {\n  padding: 12px;\n  font-size: 16px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.edit_lead_customet_ {\n  background-color: #007bff;\n  color: white;\n  padding: 14px;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.edit_lead_customet_:hover {\n  background-color: #0056b3;\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .edit_lead_form_container {\n    padding: 15px;\n    margin-top: 10px;\n  }\n\n  .edit_lead_form {\n    flex-direction: column;\n  }\n\n  .edit_lead_input {\n    margin-bottom: 16px;\n  }\n\n  .edit_lead_input input,\n  .edit_lead_input select {\n    padding: 10px;\n  }\n\n  .edit_lead_form_container h2 {\n    font-size: 22px;\n  }\n\n  .edit_lead_customet_review_input {\n    font-size: 14px;\n  }\n\n  .edit_lead_customet_ {\n    padding: 12px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .edit_lead_form_container {\n    padding: 10px;\n    margin-top: 10px;\n  }\n\n  .edit_lead_input input,\n  .edit_lead_input select,\n  .edit_lead_customet_review_input {\n    font-size: 14px;\n    padding: 10px;\n  }\n\n  .edit_lead_customet_ {\n    padding: 10px;\n    font-size: 14px;\n  }\n\n  .edit_lead_form_container h2 {\n    font-size: 20px;\n  }\n}\n\n/* review  css */\n\n.add_deview_main_container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.add_deview_container {\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 100%;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  position: relative;\n  margin: 10px;\n}\n\n.add_deview_container p {\n  font-size: 22px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.addreview_close_btn {\n  position: absolute;\n  top: 5px;\n  right: 10px;\n\n  border: none;\n  font-size: 20px;\n  color: #333;\n  cursor: pointer;\n  transition: color 0.3s;\n  height: 40px;\n  width: 40px;\n  background-color: red;\n  border-radius: 50px;\n  color: white;\n}\n\n.addreview_close_btn:hover {\n  color: #007bff;\n}\n\n.add_review_from {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.add_review_input {\n  padding: 12px;\n  font-size: 16px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  outline: none;\n}\n\n.add_review_submit_button {\n  background-color: #007bff;\n  color: white;\n  padding: 14px;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.add_review_submit_button:hover {\n  background-color: #0056b3;\n}\n\n@media (max-width: 1024px) {\n  .add_deview_container {\n    max-width: 80%;\n    padding: 20px;\n  }\n\n  .add_deview_container p {\n    font-size: 20px;\n  }\n\n  .add_review_input,\n  .add_review_submit_button {\n    font-size: 14px;\n    padding: 12px;\n  }\n}\n\n@media (max-width: 768px) {\n  .add_deview_container {\n    max-width: 90%;\n    padding: 15px;\n  }\n\n  .add_deview_container p {\n    font-size: 18px;\n  }\n\n  .add_review_input,\n  .add_review_submit_button {\n    font-size: 14px;\n    padding: 10px;\n  }\n\n  .addreview_close_btn {\n    font-size: 18px;\n    height: 35px;\n    width: 35px;\n    background-color: red;\n    color: wheat;\n    border-radius: 50px;\n  }\n}\n\n@media (max-width: 480px) {\n  .add_deview_container {\n    max-width: 95%;\n    padding: 10px;\n  }\n\n  .add_deview_container p {\n    font-size: 16px;\n  }\n\n  .add_review_input,\n  .add_review_submit_button {\n    font-size: 14px;\n    padding: 8px;\n  }\n\n  .addreview_close_btn {\n    font-size: 16px;\n    height: 30px;\n    width: 30px;\n  }\n}\n.lead_button_loading {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.lead_spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: lead-spin 0.7s linear infinite;\n}\n\n@keyframes lead-spin {\n  to { transform: rotate(360deg); }\n}\n\n.lead_button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n.add_lead_scroll {\n  max-height: 90vh;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n/* optional: nicer scrollbar */\n.add_lead_scroll::-webkit-scrollbar {\n  width: 6px;\n}\n.add_lead_scroll::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 3px;\n}\n.edit_lead_error_banner {\n  background: #fdecea;\n  color: #b3261e;\n  border: 1px solid #f5c6c2;\n  padding: 10px 14px;\n  border-radius: 6px;\n  margin-bottom: 16px;\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
